import React from "react";
import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";

import { RoleChip, crmUi } from "./CrmUi";

const NetworkNode = ({ node, level = 0 }) => (
  <Box sx={{ position: "relative" }}>
    <Box
      sx={{
        ml: level * 3.5,
        position: "relative",
        "&:before": level
          ? {
              content: '""',
              position: "absolute",
              left: -14,
              top: -16,
              bottom: 18,
              width: 1,
              bgcolor: "#dfe3e8",
            }
          : undefined,
        "&:after": level
          ? {
              content: '""',
              position: "absolute",
              left: -14,
              top: 18,
              width: 14,
              height: 1,
              bgcolor: "#dfe3e8",
            }
          : undefined,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={0.9}
        alignItems={{ xs: "flex-start", sm: "center" }}
        sx={{
          px: 1.1,
          py: 0.85,
          mb: 0.65,
          bgcolor: "#fff",
          border: `1px solid ${crmUi.border}`,
          borderRadius: 1.25,
          maxWidth: 720,
        }}
      >
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: 1,
            display: "grid",
            placeItems: "center",
            bgcolor: level === 0 ? "#fff0f1" : "#f4f6f8",
            color: level === 0 ? "primary.main" : crmUi.muted,
            flexShrink: 0,
          }}
        >
          {node.children?.length ? (
            <AccountTreeOutlinedIcon sx={{ fontSize: 17 }} />
          ) : (
            <ApartmentOutlinedIcon sx={{ fontSize: 17 }} />
          )}
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: 11.5, fontWeight: 560, color: crmUi.text }} noWrap>
            {node.name}
          </Typography>
          <Typography sx={{ mt: 0.1, fontSize: 9.8, color: crmUi.muted }} noWrap>
            {node.relation} · Debiteras av {node.billedBy}
          </Typography>
        </Box>

        <RoleChip value={node.role} />
        <Typography sx={{ color: crmUi.subtle, fontSize: 9.5, flexShrink: 0 }}>
          Nivå {level + 1}
        </Typography>
      </Stack>
    </Box>

    {node.children?.map(child => (
      <NetworkNode key={child.id} node={child} level={level + 1} />
    ))}
  </Box>
);

const NetworkTree = ({ roots }) => (
  <Box sx={{ py: 0.5 }}>
    {roots.map(root => (
      <NetworkNode key={root.id} node={root} />
    ))}
  </Box>
);

export default NetworkTree;
